import { ActionReducerMap, MetaReducer } from '@ngrx/store';

import * as fromPD from './reducers/pd.reducer';
import { environment } from '../environments/environment';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';

// Root state interface
export interface AppState {
  pd: fromPD.State;
  router: RouterReducerState<any>;
  // Add other feature states here as needed
}

// Root reducers
export const reducers: ActionReducerMap<AppState> = {
  pd: fromPD.Reducer,
  router: routerReducer,
  // Add other reducers here
};

// Meta-reducers for development (like logging)
export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [] : [];
